import React, {forwardRef, useState} from "react";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ViewIcon, ViewOffIcon} from "@hugeicons/core-free-icons";
import {a, fieldSx} from "./authStyles";

// Filled password field with a show/hide eye. Forwards its ref so it can sit inside <Fade>.
export const AuthPasswordField = forwardRef(({sx, ...props}, ref) => {
  const [show, setShow] = useState(false);

  return (
    <TextField
      ref={ref}
      variant={"filled"}
      fullWidth
      {...props}
      type={show ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              aria-label={show ? "Hide password" : "Show password"}
              onClick={() => setShow(prev => !prev)}
              sx={{color: a.muted, "&:hover": {color: a.accentText, bgcolor: "transparent"}}}
            >
              <HugeiconsIcon icon={show ? ViewOffIcon : ViewIcon} size={18}/>
            </IconButton>
          </InputAdornment>
        ),
      }}
      sx={{...fieldSx, ...sx}}
    />
  );
});
